import React from 'react';
import clsx from 'clsx';

export type BadgeVariant = 'brand' | 'neutral' | 'platform' | 'outline';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'brand',
  size = 'md',
  className,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors select-none leading-none text-center';

  const sizeStyles = {
    sm: 'h-6 px-2.5 text-[11px] rounded-md gap-1',
    md: 'h-7 px-3 text-xs rounded-md gap-1.5',
  };

  const variantStyles = {
    brand: 'bg-primary-50 text-primary-800 border border-primary-200/80 font-semibold',
    neutral: 'bg-slate-100 text-slate-700 border border-slate-200/80',
    platform: 'bg-slate-900 text-white font-semibold border border-slate-900',
    outline: 'bg-transparent text-slate-700 border border-slate-300',
  };

  return (
    <span
      className={clsx(baseStyles, sizeStyles[size], variantStyles[variant], className)}
      {...props}
    >
      {children}
    </span>
  );
};
